var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _ellipse, _ellipse2, _circle2, _circle3, _path8, _ellipse3, _ellipse4, _path9, _path10, _path11, _path12, _circle4, _circle5, _circle6, _path13, _path14, _path15, _path16, _circle7, _path17, _path18, _path19, _path20, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 941.404,
    height: 435.42,
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m84.494 414.524-1.268-.475c-.278-.105-27.992-10.724-40.975-34.8-12.983-24.077-6.625-53.066-6.56-53.356l.3-1.32 1.266.475c.279.105 27.992 10.723 40.975 34.8s6.626 53.066 6.56 53.355ZM44.33 378.128c10.976 20.357 32.877 30.792 38.426 33.174 1.055-5.947 4.364-29.997-6.603-50.334-10.965-20.335-32.874-30.786-38.425-33.174-1.056 5.951-4.364 29.999 6.602 50.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0cde1",
    d: "M52.173 370.804C75.504 384.84 84.49 412.72 84.49 412.72s-28.842 5.123-52.173-8.914S0 361.89 0 361.89s28.842-5.123 52.173 8.914"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M798.85 5.362H538.68V0H420.71v5.362H159.468a17.6 17.6 0 0 0-17.599 17.599v356.252a17.6 17.6 0 0 0 17.599 17.599H798.85a17.6 17.6 0 0 0 17.598-17.599V22.961a17.6 17.6 0 0 0-17.598-17.599"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fce40a",
    d: "M165.464 36.464h627.391v353.913H165.464z",
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.623,
    cy: 20.377,
    r: 6.435,
    fill: "#fce40a",
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M756.838 81.507h-29.74v-29.74h29.74Zm-28.447-1.293h27.154V53.06H728.39ZM834.065 383.942h-61.23v-4.412a.875.875 0 0 0-.874-.874h-20.993a.875.875 0 0 0-.875.874v4.412h-13.12v-4.412a.875.875 0 0 0-.875-.874h-20.993a.875.875 0 0 0-.875.874v4.412h-13.12v-4.412a.875.875 0 0 0-.875-.874h-20.993a.875.875 0 0 0-.875.874v4.412h-13.12v-4.412a.875.875 0 0 0-.875-.874H643.38a.875.875 0 0 0-.874.874v4.412h-13.121v-4.412a.875.875 0 0 0-.875-.874h-20.993a.875.875 0 0 0-.874.874v4.412h-13.12v-4.412a.875.875 0 0 0-.876-.874h-20.993a.875.875 0 0 0-.874.874v4.412h-13.12v-4.412a.875.875 0 0 0-.876-.874H392.34a.875.875 0 0 0-.875.874v4.412h-13.12v-4.412a.875.875 0 0 0-.875-.874h-20.993a.875.875 0 0 0-.875.874v4.412h-13.12v-4.412a.875.875 0 0 0-.875-.874h-20.993a.875.875 0 0 0-.874.874v4.412h-13.121v-4.412a.875.875 0 0 0-.875-.874H284.75a.875.875 0 0 0-.874.874v4.412h-13.12v-4.412a.875.875 0 0 0-.876-.874h-20.992a.875.875 0 0 0-.875.874v4.412h-13.12v-4.412a.875.875 0 0 0-.875-.874h-20.993a.875.875 0 0 0-.875.874v4.412h-13.12v-4.412a.875.875 0 0 0-.875-.874h-20.993a.875.875 0 0 0-.875.874v4.412h-40.236a20.993 20.993 0 0 0-20.993 20.993v9.492a20.993 20.993 0 0 0 20.993 20.993h698.014a20.993 20.993 0 0 0 20.993-20.993v-9.492a20.993 20.993 0 0 0-20.993-20.993"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M28.711 413.883h912.693v2.785H28.711zM754.072 233.67h-202v-115h202Zm-200-2h198v-111h-198ZM384.072 256.67h-180v-112h180Zm-178-2h176v-108h-176Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0cde1",
    d: "m288.166 213.67-.173-2.236c-.515-4.643 1.033-9.717 5.332-14.877 3.87-4.558 6.02-7.912 6.02-11.782 0-4.386-2.751-7.31-8.17-7.395a15.3 15.3 0 0 0-8.685 2.666l-2.064-5.418c2.838-2.065 7.74-3.44 12.297-3.44 9.89 0 14.362 6.106 14.362 12.64 0 5.85-3.268 10.063-7.396 14.965-3.783 4.471-5.16 8.256-4.902 12.641l.086 2.237Zm-1.892 12.04a5.084 5.084 0 0 1 5.16-5.417c3.01 0 5.074 2.235 5.074 5.418a5.121 5.121 0 1 1-10.234 0M647.166 188.67l-.173-2.236c-.515-4.643 1.033-9.717 5.332-14.877 3.87-4.558 6.02-7.912 6.02-11.782 0-4.386-2.751-7.31-8.17-7.395a15.3 15.3 0 0 0-8.685 2.666l-2.064-5.418c2.838-2.065 7.74-3.44 12.297-3.44 9.89 0 14.362 6.106 14.362 12.64 0 5.85-3.268 10.063-7.396 14.965-3.783 4.471-5.16 8.256-4.902 12.641l.086 2.237Zm-1.892 12.04a5.084 5.084 0 0 1 5.16-5.417c3.01 0 5.074 2.235 5.074 5.418a5.121 5.121 0 1 1-10.234 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 482.693,
    cy: 260.849,
    r: 86.292,
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m449.365 379.018-25.797-4.67 8.367-53.864 25.796 4.67zM483.527 329.824l25.796 4.67-8.367 46.217-25.796-4.67z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 626.082,
    cy: 611.196,
    fill: "#2f2e41",
    rx: 8.192,
    ry: 21.846,
    transform: "rotate(-78.587 419.5 574.055)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 572.111,
    cy: 611.257,
    fill: "#2f2e41",
    rx: 8.192,
    ry: 21.846,
    transform: "rotate(-82.454 374.916 568.89)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.734,
    cy: 239.741,
    r: 29.492,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 500.856,
    cy: 229.17,
    r: 9.831,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M414.62 166.972c-1.297-31.947 26.236-59.006 61.498-60.438s64.9 23.304 66.197 55.251-23.214 39.205-58.475 40.638-67.922-3.504-69.22-35.451"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 691.67,
    cy: 477.418,
    fill: "#2f2e41",
    rx: 43.146,
    ry: 13.545,
    transform: "rotate(-12.91 -399.53 932.675)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 522.282,
    cy: 505.587,
    fill: "#2f2e41",
    rx: 43.146,
    ry: 13.545,
    transform: "rotate(-12.91 -568.918 960.844)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M458.993 294.855a19.662 19.662 0 0 0 38.694 7.005c1.934-10.685-6.327-14.466-17.012-16.4s-19.748-1.29-21.682 9.395"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0cde1",
    d: "M154.535 13.122h141.887v134.967H154.535z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M170.658 29.246h109.64v83.842h-109.64z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M170.55 122.979h59.637v3.139H170.55zM170.55 132.396h59.637v3.139H170.55z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.167,
    cy: 71.19,
    r: 12.555,
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 225.478,
    cy: 71.19,
    r: 12.555,
    fill: "#fce40a",
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    }
  }), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.789,
    cy: 71.19,
    r: 12.555,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.478,
    cy: 20.969,
    r: 6.278,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0cde1",
    d: "M222.022 274.459h141.887v134.967H222.022z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M238.146 290.582h109.64v83.842h-109.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fce40a",
    d: "M262.272 304.361h38.437v38.437h-38.437z",
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M276.986 313.973v46.673h46.674v-46.673Zm44.65 44.649H279.01v-42.625h42.625Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M238.037 382.747h59.637v3.139h-59.637z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.966,
    cy: 282.306,
    r: 6.278,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0cde1",
    d: "M591.437 234.053h141.887V369.02H591.437z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M607.56 250.176H717.2v83.842H607.56z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M650.587 315.812h23.587v6.99h-23.587zM622.072 261.393h80.617v2.996h-80.617zM622.072 270.879h80.617v2.996h-80.617zM622.072 280.365h80.617v2.996h-80.617zM622.072 289.851h80.617v2.996h-80.617zM622.072 299.337h80.617v2.996h-80.617z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M607.451 342.341h59.637v3.139h-59.637zM607.451 350.187h83.178v3.139h-83.178z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 662.38,
    cy: 241.9,
    r: 6.278,
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1);
export default __webpack_public_path__ + "static/media/a1.e774a18626e6b5a844ef63bb205d02c5.svg";
export { ForwardRef as ReactComponent };